// REACT
import React from "react";

// MATERIAL-UI
import { Typography, AppBar, IconButton, Toolbar } from "@mui/material";
import ArrowLeft from "src/icons/ArrowLeftIcon";

interface ModalHeaderMobileprops {
  title: string;
  onClose: (event: React.MouseEvent<HTMLDivElement | HTMLAnchorElement>) => void;
}

const ModalHeaderMobile = (props: ModalHeaderMobileprops) => {
  return (
    <AppBar sx={{ position: "relative" }}>
      <Toolbar>
        <IconButton
          component="a"
          edge="start"
          color="inherit"
          onClick={props.onClose}
          aria-label="close"
        >
          <ArrowLeft color="#fff" />
        </IconButton>
        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
          {props.title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default ModalHeaderMobile;
